import { Injectable } from '@angular/core';
import { ParseService } from './parse.service';
import { TraceService } from './trace.service';
import { Observable } from 'rxjs/Observable';
import 'parse';
import { LocalstorageService } from './localstorage.service';
const parse: typeof Parse = require('parse');

@Injectable()
export class AuthService {
  constructor(
    private auth$: ParseService,
    private _traceService: TraceService,
    private _localStorageService : LocalstorageService
  ) { }

  userIsLoggedIn() {
    if (this.auth$.currentUser == null) {
      return false;
    } else {
      const expirationDate = this.auth$.currentUser.get('expirationDate');
      //console.log("sbe ", expirationDate);
      const today = new Date();
      if (!expirationDate || expirationDate > today) {
        return true;
      } else {
        parse.User.logOut();
        return false;
      }
    }
  }
  login(email: string, password: string) {
    return this.auth$.login(email, password);
  }
  logout(): Observable<boolean> {
    this._localStorageService.clear();
    this._traceService.saveTrace(null, 'disconnected');
    return this.auth$.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/service/auth.service.ts